<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="appStore.sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />
    <breadcrumb
      id="breadcrumb-container"
      class="breadcrumb-container"
      v-if="!settingsStore.topNav"
    />
    <top-nav id="topmenu-container" class="topmenu-container" v-if="settingsStore.topNav" />

    <div class="right-menu">
      <template v-if="appStore.device !== 'mobile'">
        <header-search id="header-search" class="right-menu-item" />

        <!-- <el-tooltip content="源码地址" effect="dark" placement="bottom">
          <benagenGit id="benagen-git" class="right-menu-item hover-effect" />
        </el-tooltip>

        <el-tooltip content="文档地址" effect="dark" placement="bottom">
          <benagenDoc id="benagen-doc" class="right-menu-item hover-effect" />
        </el-tooltip> -->

        <screenfull id="screenfull" class="right-menu-item hover-effect" />

        <el-tooltip content="主题模式" effect="dark" placement="bottom">
          <div class="right-menu-item hover-effect theme-switch-wrapper" @click="toggleTheme">
            <svg-icon v-if="settingsStore.isDark" icon-class="sunny" />
            <svg-icon v-if="!settingsStore.isDark" icon-class="moon" />
          </div>
        </el-tooltip>

        <!-- 设置的是element plus的图标默认大小，见：main.js -->
        <!-- <el-tooltip content="布局大小" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect" />
        </el-tooltip> -->

        <el-dropdown trigger="click" @command="handleAiMenuCommand">
          <div class="ai-assistant-btn">
            <span class="ai-assistant-glow"></span>
            <svg class="ai-spark-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M12 2L13.6 8.4L20 10L13.6 11.6L12 18L10.4 11.6L4 10L10.4 8.4L12 2Z" />
              <path
                d="M18.5 14L19.1 15.9L21 16.5L19.1 17.1L18.5 19L17.9 17.1L16 16.5L17.9 15.9L18.5 14Z"
              />
            </svg>
            <span class="ai-assistant-text">AI</span>
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="knowledge">知识库</el-dropdown-item>
              <el-dropdown-item command="progress">进展查询</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>

        <div class="flex gap-x-1">
          <template v-if="env.VITE_APP_ENV === 'dev'">
            <el-popover width="200" placement="bottom" class="">
              <template #reference>
                <el-text>{{ userStore?.nickName }}</el-text>
              </template>
              <div class="flex flex-col items-center justify-center">
                <el-text class="mb-1">用户角色:</el-text>
                <div class="flex flex-col items-center justify-center gap-y-1">
                  <div class="" v-for="item in userStore?.userInfo?.roles" :key="item">
                    <el-tag type="primary">{{ item?.roleName }}</el-tag>
                  </div>
                </div>
              </div>
            </el-popover>
          </template>
          <template v-else>
            <el-text>{{ userStore?.nickName }}</el-text>
          </template>
        </div>
      </template>
      <div class="avatar-container">
        <el-dropdown @command="handleCommand" class="right-menu-item hover-effect" trigger="click">
          <div class="avatar-wrapper">
            <img :src="userStore.avatar" class="user-avatar" />
            <el-icon>
              <caret-bottom />
            </el-icon>
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <router-link to="/user/profile">
                <el-dropdown-item>个人中心</el-dropdown-item>
              </router-link>
              <el-dropdown-item command="setLayout" v-if="settingsStore.showSettings">
                <span>布局设置</span>
              </el-dropdown-item>
              <el-dropdown-item command="downloadOperationManual">
                <span>操作手册</span>
              </el-dropdown-item>
              <el-dropdown-item divided command="logout">
                <span>退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>

    <!-- AI 助手蒙版：阻断对后面页面的操作，点击可关闭 -->
    <transition name="ai-mask">
      <div v-show="aiDialogVisible" class="ai-chat-mask" @click="aiDialogVisible = false"></div>
    </transition>
    <!-- AI 助手悬浮面板（组件自带全屏/关闭按钮，关闭走 onClose 回调） -->
    <transition name="ai-panel">
      <div v-show="aiDialogVisible" ref="chatRoot" class="ai-chat-container"></div>
    </transition>

    <!-- 知识库对话弹窗 -->
    <el-dialog
      v-model="knowledgeDialogVisible"
      width="820px"
      top="8vh"
      append-to-body
      modal-class="knowledge-dialog-overlay"
      :fullscreen="knowledgeFullscreen"
      :show-close="false"
      :close-on-click-modal="false"
      class="knowledge-dialog"
    >
      <template #header="{ close }">
        <div class="knowledge-dialog-header">
          <span class="knowledge-dialog-title">知识库</span>
          <div class="knowledge-dialog-actions">
            <el-tooltip :content="knowledgeFullscreen ? '取消全屏' : '全屏'" placement="top">
              <el-icon class="action-btn" @click="knowledgeFullscreen = !knowledgeFullscreen">
                <ScaleToOriginal v-if="knowledgeFullscreen" />
                <FullScreen v-else />
              </el-icon>
            </el-tooltip>
            <el-tooltip content="关闭" placement="top">
              <el-icon class="action-btn" @click="close"><Close /></el-icon>
            </el-tooltip>
          </div>
        </div>
      </template>
      <KnowledgeChat :username="userStore.nickName" />
    </el-dialog>
  </div>
</template>

<script setup>
import { ElMessageBox } from "element-plus";
import Breadcrumb from "@/components/Breadcrumb";
import TopNav from "@/components/TopNav";
import Hamburger from "@/components/Hamburger";
import Screenfull from "@/components/Screenfull";
// import SizeSelect from "@/components/SizeSelect";
import HeaderSearch from "@/components/HeaderSearch";
// import benagenGit from "@/components/BenaGen/Git";
// import benagenDoc from "@/components/BenaGen/Doc";
import useAppStore from "@/store/modules/app";
import useUserStore from "@/store/modules/user";
import useSettingsStore from "@/store/modules/settings";
import { OperationManualUrl } from "@/utils/apiHelper.js";
import { downloadTool } from "@/utils/tools.js";
import { notifyOtherTabsLogout } from "@/utils/channel.js";
import LisChat from "lis-chat";
import { getToken } from "@/utils/auth";
import KnowledgeChat from "@/components/AiChat/KnowledgeChat.vue";
import { Close, FullScreen, ScaleToOriginal } from "@element-plus/icons-vue";

const appStore = useAppStore();
const userStore = useUserStore();
const settingsStore = useSettingsStore();

function toggleSideBar() {
  appStore.toggleSideBar();
}

function downloadOperationManual() {
  downloadTool(OperationManualUrl, "贝纳信息管理系统-客户操作手册.pdf");
}

function handleCommand(command) {
  switch (command) {
    case "setLayout":
      setLayout();
      break;
    case "logout":
      logout();
      break;
    case "downloadOperationManual":
      downloadOperationManual();
      break;
    default:
      break;
  }
}

const env = import.meta.env;

// console.log(env.VITE_APP_ENV);

function logout() {
  ElMessageBox.confirm("确定注销并退出系统吗？", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning"
  })
    .then(() => {
      userStore.logOut().then(() => {
        notifyOtherTabsLogout();
        location.href = "/index";
      });
    })
    .catch(() => {});
}

const emits = defineEmits(["setLayout"]);

function setLayout() {
  emits("setLayout");
}

function toggleTheme() {
  settingsStore.toggleTheme();
}

const aiDialogVisible = ref(false);
const chatRoot = ref(null);
let chatInstance = null;

function openAiChat() {
  aiDialogVisible.value = true;
  // 等待 DOM 渲染后初始化
  nextTick(() => {
    if (!chatInstance && chatRoot.value) {
      chatInstance = LisChat.create(chatRoot.value, {
        apiBase: import.meta.env.VITE_APP_BASE_API + "/produce/ai",
        // apiBase: "/chat-api",
        apiToken: getToken(),
        userId: userStore.id,
        username: userStore.name,
        height: "100%",
        // 组件自带关闭按钮(✕)：点击后组件隐藏自身并回调，同步隐藏外层悬浮面板
        onClose: function () {
          aiDialogVisible.value = false;
        },
        // 登录态过期无感续期：优先取 Cookie 里最新 token（用户可能在别的标签页重登过），
        // 变了就用新 token 自动重试；没变（真的过期）则交由组件提示用户重新登录。
        // ★ 回调第二参数 chat 为组件实例（v1.0.3+，不再依赖闭包引用外部变量）
        onAuthExpired: function (done, chat) {
          var fresh = getToken();
          var changed = !!fresh && fresh !== chat.opts.apiToken;
          if (changed) chat.setToken(fresh);
          done(changed);
        }
      });
    } else if (chatInstance) {
      // 每次打开主动同步最新 token，双保险
      var latest = getToken();
      if (latest) chatInstance.setToken(latest);
      // 内置 ✕ 会把组件内部 display:none，重新打开需恢复显示
      chatInstance.reopen();
    }
  });
}

const knowledgeDialogVisible = ref(false);
const knowledgeFullscreen = ref(false);

//  AI 助手下拉菜单:知识库 / 进展查询
function handleAiMenuCommand(command) {
  if (command === "knowledge") {
    knowledgeDialogVisible.value = true;
  } else if (command === "progress") {
    openAiChat();
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: var(--navbar-bg);
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .topmenu-container {
    position: absolute;
    left: 50px;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: var(--navbar-text);
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }

      &.theme-switch-wrapper {
        display: flex;
        align-items: center;

        svg {
          transition: transform 0.3s;

          &:hover {
            transform: scale(1.15);
          }
        }
      }
    }

    .ai-assistant-btn {
      position: relative;
      display: flex;
      align-items: center;
      align-self: center;
      gap: 4px;
      margin: 0 8px;
      padding: 5px 12px;
      border: none;
      border-radius: 20px;
      cursor: pointer;
      font-size: 13px;
      font-weight: 700;
      letter-spacing: 0.5px;
      color: #fff;
      background: linear-gradient(135deg, #6a5cff 0%, #9b5cff 45%, #ff5caa 100%);
      background-size: 200% 200%;
      box-shadow:
        0 0 10px rgba(124, 92, 255, 0.55),
        0 2px 6px rgba(0, 0, 0, 0.15);
      transition:
        transform 0.25s ease,
        box-shadow 0.25s ease,
        background-position 0.6s ease;
      animation: ai-gradient-move 4s ease infinite;
      overflow: hidden;

      .ai-spark-icon {
        width: 16px;
        height: 16px;
        filter: drop-shadow(0 0 2px rgba(255, 255, 255, 0.85));
        animation: ai-spark-rotate 3s ease-in-out infinite;
      }

      .ai-assistant-text {
        line-height: 1;
      }

      .ai-assistant-glow {
        position: absolute;
        inset: 0;
        border-radius: inherit;
        pointer-events: none;
        animation: ai-pulse 2.2s ease-out infinite;
      }

      &:hover {
        transform: translateY(-1px) scale(1.04);
        box-shadow:
          0 0 16px rgba(124, 92, 255, 0.8),
          0 4px 10px rgba(0, 0, 0, 0.2);
        background-position: 100% 50%;
      }

      &:active {
        transform: translateY(0) scale(0.98);
      }
    }

    @keyframes ai-gradient-move {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
    }

    @keyframes ai-spark-rotate {
      0%,
      100% {
        transform: rotate(0deg) scale(1);
      }
      50% {
        transform: rotate(15deg) scale(1.1);
      }
    }

    @keyframes ai-pulse {
      0% {
        box-shadow: 0 0 0 0 rgba(155, 92, 255, 0.5);
      }
      70% {
        box-shadow: 0 0 0 8px rgba(155, 92, 255, 0);
      }
      100% {
        box-shadow: 0 0 0 0 rgba(155, 92, 255, 0);
      }
    }

    .avatar-container {
      margin-right: 40px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        i {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>

<style lang="scss">
/* AI 助手居中面板：组件自带全屏(⛶)与关闭(✕)按钮，这里只负责承载与定位 */
/* 用 inset+margin 居中而非 transform：避免创建 containing block，保证组件内置全屏(fixed)能铺满视口 */
.ai-chat-container {
  position: fixed;
  inset: 0;
  margin: auto;
  width: 60vw;
  max-width: 1100px;
  height: 72vh;
  max-height: 820px;
  z-index: 2000;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  box-shadow:
    0 12px 40px rgba(0, 21, 41, 0.18),
    0 2px 8px rgba(0, 21, 41, 0.1);

  @media (max-width: 640px) {
    width: calc(100vw - 24px);
    height: calc(100vh - 84px);
  }
}

/* AI 助手蒙版：盖住页面、垫在面板下方（面板 2000，组件内置全屏 9999 均在其上） */
.ai-chat-mask {
  position: fixed;
  inset: 0;
  z-index: 1999;
  background: rgba(0, 21, 41, 0.45);
}

/* 蒙版淡入淡出 */
.ai-mask-enter-active,
.ai-mask-leave-active {
  transition: opacity 0.2s ease;
}

.ai-mask-enter-from,
.ai-mask-leave-to {
  opacity: 0;
}

/* 面板打开/关闭动效（transform 仅存在于动画帧，不残留） */
.ai-panel-enter-active,
.ai-panel-leave-active {
  transition:
    opacity 0.2s ease,
    transform 0.2s ease;
}

.ai-panel-enter-from,
.ai-panel-leave-to {
  opacity: 0;
  transform: translateY(12px) scale(0.98);
}
</style>

<style lang="scss">
/*  知识库 el-dialog(append-to-body 后挂在 body 下,需非 scoped) */
.knowledge-dialog-overlay {
  //  始终保持在最高层,压过其他全屏遮罩(如 AI 助手 overlay 的 z-index: 2000)
  // z-index: 3000 !important;

  .el-overlay-dialog {
    overflow: hidden;
  }
}

.knowledge-dialog {
  border-radius: 14px;

  .el-dialog__header {
    padding: 0 16px 12px 0;
    margin-right: 0;
    border-bottom: 1px solid #e2e8f0;
  }

  .el-dialog__body {
    padding: 0;
    height: 552px; // 整体高度约 600px,减去头部
    overflow: hidden;
  }

  //  全屏模式: 头部固定,聊天区撑满剩余高度
  &.is-fullscreen {
    display: flex;
    flex-direction: column;
    max-height: 100%;
    overflow: hidden;
    padding-bottom: 0 !important;

    .el-dialog__header {
      flex-shrink: 0;
    }

    .el-dialog__body {
      height: auto;
      flex: 1;
    }
  }
}

.knowledge-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.knowledge-dialog-title {
  font-weight: 700;
  font-size: 15px;
  color: #1e293b;
}

.knowledge-dialog-actions {
  display: flex;
  align-items: center;
  gap: 10px;

  .action-btn {
    color: #64748b;
    font-size: 17px;
    cursor: pointer;
    transition: color 0.15s;

    &:hover {
      color: #2563eb;
    }
  }
}
</style>
